module.exports = __webpack_public_path__ + "static/media/company-profile.f67db563.svg";